/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export const REJECTED_REASONS = [
  'ADULT_CONTENT',
  'BLANK_CONTENT',
  'MALFORMED_CLICK_THROUGH',
  'DRUG_RELATED_CONTENT',
  'WEAPON_RELATED_CONTENT',
  'HATE_SPEECH_CONTENT',
  'LANDING_PAGE_REJECTED',
  'OFFENSIVE_CONTENT',
  'UNACCEPTABLE_VISUAL_EFFECTS',
  'DECEPTIVE_CONTENT',
  'GAMBLING_CONTENT',
  'PROHIBITED_ELECTION_RELATED_CONTENT',
  'SHOCKING_CONTENT',
  'MALWARE_CONTENT',
  'POOR_QUALITY'
];

export function createReviewApproveHandler(list: any, LineItem: any): () => void {
  return function() {
    const bulkSaveLineItems = _.map(list.bulkSelection, function(val: any) {
      return {id: val.lineItem.id, userState: 'APPROVED'};
    });
    list.miscBulkAction(null, list, bulkSaveLineItems, LineItem);
    list.deselectAll();
  };
}
